import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/rh/conges")({
  staticData: {
    permission: PERMISSIONS.RH.CONGES.VIEW,
  },
  component: () => <Outlet />,
});
